import { useCenters, useCenterStat } from "../../../hooks/centers.hooks";
import { CommandStatus } from "../../../types/command.types";
import { Button, Flex } from "@chakra-ui/react";

type Props = {
	status?: CommandStatus;
	setStatus: (status?: CommandStatus) => void;
	setNotStatus: (status?: CommandStatus) => void;
};

const OrdersDraftStatusFilter = ({
	status,
	setStatus,
	setNotStatus,
}: Props) => {
	const { center } = useCenters();
	const { data: stats } = useCenterStat(center?.id);
	const hasDraftFilter = status === CommandStatus.DRAFT;

	const handleToggle = () => {
		if (hasDraftFilter) {
			setStatus(undefined);
			setNotStatus(CommandStatus.DRAFT);
		} else {
			setStatus(CommandStatus.DRAFT);
			setNotStatus(undefined);
		}
	};

	return (
		<Flex pl={4}>
			{stats && (
				<Button
					variant="link"
					color="brand.700"
					backgroundColor={hasDraftFilter ? "brand.50" : undefined}
					onClick={handleToggle}
					px={4}
				>
					Brouillons&nbsp;<span>({stats.commandsDraftCount})</span>
				</Button>
			)}
		</Flex>
	);
};

export default OrdersDraftStatusFilter;
